// Author: T4professor

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { DocuSignModalComponent } from '../docusign/docusign-modal.component';
import { DocuSignService } from 'src/app/services/docusign-service/docusign-service';
import { UserService } from 'src/app/services/user/user.service';
import { ICellRendererParams } from 'ag-grid-community';
import AppConstants, { BusinessType, system_admin} from 'src/app/shared/common-components/AppConstants';


@Component({
    selector: "app-button-rendererdownload",
    template: `
    <button class="font-sans-3xs usa-button" (click)="onClick($event)">
      {{ label }}
    </button>
  `,
    standalone: false
})
export class ButtonRendererDownloadComponent
  implements ICellRendererAngularComp
{
  params;
  label: string;
  isSysAdmin: boolean = false;
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    public options: ModalOptions,
    private loader: LoadingService,
    private docuSignService: DocuSignService,
    private userService: UserService
  ) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.label = this.params.label || null;
    this.userService.getCurrentUserObservable().subscribe((user) => {
      console.log(user);
      let roles = user?.roles;
      // let isSystemAdmin = from(roles).pipe.filter(role => role.name)
      this.isSysAdmin = roles.some((role) => role.name === system_admin);
      // this.isSysAdmin = result;
      this.handleLabelGenerator(this.params);
      window.addEventListener("message", this.handleMessage);

    });
  }

  handleLabelGenerator(params: any) {
    var tspSigned: boolean = false;
    var gsaSigned: boolean = false;
    var envelopeIdExist: boolean = false;
    var tspAgreement: boolean = false;
    if (params.data != null && params.data.documentType != null && params.data.documentType.includes("TSP Agreement")) {
        tspAgreement = true;
        if (params.data.tspSigned != null && params.data.tspSigned > 0) {
          tspSigned = true;
        }
        if (params.data.gsaSigned != null && params.data.gsaSigned > 0) {
          gsaSigned = true;
        }
        if (tspSigned && tspSigned && params.data.docSignEnvelopeId != null) {
          envelopeIdExist = true;
        }
      }

    if(params.data.businessType === BusinessType.FRT){  
        if (tspAgreement && !this.isSysAdmin) {
            if (tspSigned && gsaSigned) this.label = "Download";
            if (tspSigned && !gsaSigned) this.label = "Pending System Admin Signature";
            if ((!tspSigned && gsaSigned) || (!tspSigned && !gsaSigned)) this.label = "Sign";
        }
      
        if (tspAgreement && this.isSysAdmin) {
            if (tspSigned && gsaSigned) this.label = "Download";
            if (tspSigned && !gsaSigned) this.label = "Sign";
            if (!tspSigned) this.label = "Pending TSP Signature";
        }
    }
    

    if (!tspAgreement || params.data.businessType === BusinessType.HHG) this.label = "Download";
    
  }

  handleMessage = (event: MessageEvent) => {
    if (event.data === "docusign-complete") {
      this.bsModalRef.hide();
      this.loader.show();
      if (this.label === "Sign" && !this.isSysAdmin) {
        this.docuSignService
          .updateDocuSignStatusTSPSigned(this.params.data.documentManagerId)
          .subscribe((response) => {
            this.label = response;
            this.loader.hide();
          });
      }
      if (this.label === "Sign" && this.isSysAdmin) {
        this.docuSignService
          .updateDocuSignStatusGSASigned(this.params.data.documentManagerId)
          .subscribe((response) => {
            this.label = response;
            this.params.data.documentStatus = "Finalized";
            this.params.api.refreshCells({
              rowNodes: [this.params.node],
              force: true
            });
            this.loader.hide();
          });
      }
    }
  };

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.label === "Sign") {
      const initialState = {
        docMgrId: this.params.data.documentManagerId,
      };
      this.bsModalRef = this.modalService.show(DocuSignModalComponent, {
        initialState,
        class: "modal-xl",
      });
    } else {
      if (this.params.onClick instanceof Function) {
        // put anything into params u want pass into parents component
        const params = {
          event: $event,
          rowData: this.params.node.data,
          // ...something
        };
        this.params.onClick(params);
      }
    }
  }
}
